import axiosInstance from "./axiosInstance.ts";

export const templateService = {
  createTemplate: (payload) => axiosInstance.post("api/v1/templates/", payload),

  getTemplateData: (skip = 0, limit = 10, page = 1) =>
    axiosInstance.get("api/v1/templates/", {
      params: { skip, limit, page },
      headers: { Accept: "application/json" },
    }),

  getTableData: (skip = 0, limit = 10, page = 1) =>
    axiosInstance.get("/api/v1/datalake/schemas/tables?schema_name=gold", {
      params: { skip, limit, page },
      headers: { Accept: "application/json" },
    }),

  getTablePreviewData: (table_name) =>
    axiosInstance.get(`/api/v1/datalake/preview-table?table_name=${table_name.label}`, {
      headers: { Accept: "application/json" },
  }),

  deleteTemplateData: (templateId: number) =>
    axiosInstance.delete(`${`api/v1/templates`}/${templateId}`),

  getTemplateDataByid: (templateId: number) => 
    axiosInstance.get(`${`api/v1/templates`}/${templateId}`, {
      // params: { skip: 0, limit: 100 },
      headers: { Accept: "application/json" },
    }),
    
  editTemplateData: (templateId: number, payload: any) =>
    axiosInstance.put(`${`api/v1/templates`}/${templateId}`, payload),
  
};
